export default (tourProducts) => !!tourProducts
    .find((tourProduct) => tourProduct
        .get('tour')
        .get('cashbackAvailable'));
